import { PropertyType, Option } from 'shared/interface/globalInterface';
import { BooleanString } from 'shared/interface/globalInterface';
import { Nullable } from 'utils/types';
import { AssetToSaleType, FundUseValueEnum, BackendFundUseValueEnum } from './types';

export const logicalMapBackToFront = (is: boolean): BooleanString => (is ? 'true' : 'false');

export const logicalMapFrontToBack = (is: BooleanString | ''): boolean => is === 'true';

export const logicalVal = (val: boolean | '' | null | undefined): BooleanString | '' =>
  typeof val === 'boolean' ? logicalMapBackToFront(val) : '';

export const stringToBool = (value: string): boolean => value === 'true';

export const valueToBool = (value: string | undefined | null): Nullable<boolean> =>
  value ? stringToBool(value) : null;

export const toNumber = (val: string | number | undefined | null): Nullable<number> => {
  const value = Number(val);

  return val && !isNaN(value) ? value : null;
};

export const isEmptyString = (value: any) => value === '' || value === null;
export const isNotEmptyString = (value: any) => !isEmptyString(value);

export const propertyTypeFromBackendMap = (type: PropertyType): AssetToSaleType => {
  const map = new Map();
  map.set('btl_property', 'btlProperty');
  map.set('non_property', 'nonProperty');
  map.set('other_property', 'otherProperty');

  return map.get(type);
};

export const propertyTypeForBackendMap = (type: AssetToSaleType): PropertyType => {
  const map = new Map();
  map.set('btlProperty', 'btl_property');
  map.set('nonProperty', 'non_property');
  map.set('otherProperty', 'other_property');

  return map.get(type);
};

export const fundTypeMapForBackend = (type: FundUseValueEnum): BackendFundUseValueEnum => {
  const map = new Map();
  map.set(FundUseValueEnum.PURCHASE_AN_ANNUITY, BackendFundUseValueEnum.PURCHASE_AN_ANNUITY);
  map.set(FundUseValueEnum.MOVE_FUND, BackendFundUseValueEnum.MOVE_FUND);

  return map.get(type);
};

export const fundTypeMapForFrontend = (type: BackendFundUseValueEnum): FundUseValueEnum => {
  const map = new Map();
  map.set(BackendFundUseValueEnum.PURCHASE_AN_ANNUITY, FundUseValueEnum.PURCHASE_AN_ANNUITY);
  map.set(BackendFundUseValueEnum.MOVE_FUND, FundUseValueEnum.MOVE_FUND);

  return map.get(type);
};

export const yesNoOptions: Option[] = [
  { option: 'Yes', value: 'true' },
  { option: 'No', value: 'false' },
];
